/**
 * Lucide line icons for Attendance Actions (approved mockup).
 * Soft-3D ATTENDANCE_ACTION_ICONS remain in payrollActionChrome for other surfaces.
 */
import {
  BriefcaseBusiness,
  CalendarCheck2,
  CalendarOff,
  Clock3,
  Layers,
  ListChecks,
  TreePalm,
  ScanLine,
  SlidersHorizontal,
  Sparkles,
  Timer,
  Undo2,
  WalletCards,
  Zap,
} from "lucide-react";

const stroke = 1.7;

function wrap(Icon) {
  return function AttendanceLucideIcon({ size = 20, className = "", ...rest }) {
    return (
      <Icon
        size={size}
        strokeWidth={stroke}
        className={className}
        aria-hidden
        {...rest}
      />
    );
  };
}

export const ATTENDANCE_ACTION_LUCIDE_ICONS = {
  change_status: wrap(CalendarCheck2),
  apply_leave: wrap(TreePalm),
  change_shift: wrap(Clock3),
  change_wo: wrap(CalendarOff),
  regularise: wrap(ScanLine),
  short_leave: wrap(Timer),
  lop_reversal: wrap(Undo2),
  leave_adjustment: wrap(SlidersHorizontal),
  leave_balance: wrap(WalletCards),
  comp_off_ledger: wrap(Layers),
  view_edit_checks: wrap(ListChecks),
  on_duty: wrap(BriefcaseBusiness),
  overtime: wrap(Zap),
  restricted_holiday: wrap(Sparkles),
};

/** @deprecated Hints removed — redesign uses fixed-height rows only. */
export const ATTENDANCE_ACTION_RAIL_HINTS = {};
